import { compile } from 'vue';
import { createRouter, createWebHistory } from 'vue-router';
import Layout from '../views/Layout';
import financeRoutes from './modules/finance';
import humanResourcesRoutes from './modules/humanresources';
import storeRoutes from './modules/store';

const routes = [
  {
    path: '/',
    name: '主页',
    component: () => import('../views/Layout'),
    redirect: '/home',//重定向
    children: [
      {
        path: '/',
        name: '首页',
        component: () => import('../views/Home/index.vue'),
        meta: {
          keepAlive: true,
          title: '首页'
        }
      },
      {
        path: '/userCenter',
        name: '个人中心',
        component: () => import('../views/userCenter/index.vue'),
      },
      {
        path: '/goods',
        component: () => import('../views/Goods'),
        children: [
          {
            path: 'list',
            name: 'list',
            component: () => import('../views/Goods/list_goods/Goodslist.vue'),
          },
          {
            path: 'category',
            name: 'category',
            component: () => import('../views/Goods/Category.vue'),
          },
          {
            path: 'addgoods',
            name: 'addgoods',
            component: () => import('../views/Goods/add_goods/AddGoods.vue'),
          },
        ],
      },
      {
        path: '/Store',
        component: () => import('../views/Store'),
        children: [
          {
            path: 'store',
            component: () => import('../views/Store/store'),
            children: [
              {
                path: 'store_list',
                name: '门店管理',
                component: () => import('../views/Store/store/store_list/store_list.vue'),
                meta: {
                  keepAlive: true,
                  title: '门店管理'
                }
              },
              {
                path: 'store_add',
                name: 'store_add',
                component: () => import('../views/Store/store/store_add/store_add.vue'),
              },
            ],
          },
          {
            path: 'item',
            component: () => import('../views/Store/item'),
            children: [
              {
                path: 'item_list',
                name: '商品档案',
                component: () => import('../views/Store/item/item_list/item_list.vue'),
              },
              {
                path: 'item_add',
                name: 'item_add',
                component: () => import('../views/Store/item/item_add/item_add.vue'),
              },
            ],
          },
        ],
      },
      {
        path: '/order',
        component: () => import('../views/Order'),
        children: [
          {
            path: 'order_list',
            name: '销售订单',
            component: () => import('../views/Order/order_list/order_list.vue'),
            meta: {
              keepAlive: true,
              title: '销售订单'
            }
          },
          {
            path: 'order_add',
            name: 'order_add',
            component: () => import('../views/Order/order_add/order_add.vue'),
          },
          {
            path: 'inventory_adjustment',
            name: '库存损益',
            component: () => import('../views/Order/inventory_adjustment/index.vue'),
            meta: {
              keepAlive: true,
              title: '库存损益'
            }
          },
          {
            path: 'goods_sale',
            name: '单品分析',
            component: () => import('../views/Order/goods_sale/index.vue'),
            meta: {
              keepAlive: true,
              title: '单品分析'
            }
          },
          {
            path: 'target_tracker',
            name: '目标跟踪',
            component: () => import('../views/Order/target_tracker/index.vue'),
            meta: {
              keepAlive: true,
              title: '目标跟踪'
            }
      },
        ],
      },
      {
        path: '/sys/user',
        name: '用户管理',
        component: () => import('../views/sys/user/index.vue'),
      },
      {
        path: '/sys/role',
        name: '角色管理',
        component: () => import('../views/sys/role/index.vue'),
      },
      {
        path: '/sys/menu',
        name: '菜单管理',
        component: () => import('../views/sys/menu/index.vue'),
      },
      {
        path: '/store/listall',
        name: '门店分组',
        component: () => import('../views/sys/group/index.vue'),
      },
      {
        path: '/bsns/department',
        name: '数据同步',
        component: () => import('../views/bsns/Department.vue'),
      },
      {
        path: '/bsns/post',
        name: '岗位管理',
        component: () => import('../views/bsns/Post.vue'),
      },
      {
        path: '/finance/contract',
        name: '合同管理',
        component: () => import('../views/Finance/contract/index.vue'),
      },
      {
        path: '/humanresources',
        name: '人事管理',
        component: () => import('../views/humanresources'),
        children: [
          {
            path: 'contacts',
            name: '通讯录',
            component: () => import('../views/humanresources/contacts/index.vue')
          },
          {
            path: 'personnel_files',
            name: '人事档案',
            component: () => import('../views/humanresources/personnel_files'),
            children: [
              {
                path: 'labor_contract',
                name: '劳动合同',
                component: () => import('../views/humanresources/personnel_files/labor_contract/index.vue')
              },
              {
                path: 'liability_insurance',
                name: '雇主责任险',
                component: () => import('../views/humanresources/personnel_files/liability_insurance/index.vue')
              },
              {
                path: 'personnel_information',
                name: '人事信息',
                component: () => import('../views/humanresources/personnel_files/personnel_information/index.vue')
              }
            ]
          },
          {
            path: 'hire_ledger',
            name: '招聘台账',
            component: () => import('../views/humanresources/hire_ledger/index.vue')
          },
          {
            path: 'administration',
            name: '行政管理',
            component: () => import('../views/humanresources/administration'),
            children: [
              {
                path: 'business_license',
                name: '营业执照',
                component: () => import('../views/humanresources/administration/business_license/index.vue')
              },
              {
                path: 'hostel',
                name: '宿舍管理',
                component: () => import('../views/humanresources/administration/hostel/index.vue')
              },
              {
                path: 'administrative_procurement',
                name: '行政采购',
                component: () => import('../views/humanresources/administration/administrative_procurement/index.vue')
              }
            ]
          },
          {
            // 访问路径：/humanresources/pointdetail/*
            path: 'pointdetail',
            name: '积分商城',
            component: () => import('../views/humanresources/pointdetail'),
            redirect: '/humanresources/pointdetail/mall_home',
            children: [
              // 商城主页（商品 + 感动故事卡片）
              {
                path: 'mall_home',
                name: '商城主页',
                component: () => import('../views/humanresources/pointdetail/mall_home/index.vue')
              },
              // 积分账户 / 流水
              {
                path: 'point_manage',
                name: '积分明细',
                component: () => import('../views/humanresources/pointdetail/point_manage/index.vue')
              },
              // 商品管理
              {
                path: 'goods_manage',
                name: '商品管理',
                component: () => import('../views/humanresources/pointdetail/goods_manage/index.vue')
              },
              // 兑换审批
              {
                path: 'exchange_order',
                name: '兑换审批',
                component: () => import('../views/humanresources/pointdetail/exchange_order/index.vue')
              },
              // 感动故事
              {
                path: 'moving_story',
                name: '感动故事',
                component: () => import('../views/humanresources/pointdetail/moving_story/index.vue')
              },
              // 改善创新（管理员人工录入）
              {
                path: 'improve_innovation',
                name: '改善创新',
                component: () => import('../views/humanresources/pointdetail/improve_innovation/index.vue')
              },
              // 积分失效提醒
              {
                path: 'expire_remind',
                name: '失效提醒',
                component: () => import('../views/humanresources/pointdetail/expire_remind/index.vue')
              }
            ]
          },
        ]
      },
      {
        path: '/delivery/costs',
        name: '配送费用',
        component: () => import('../views/delivery/costs/index.vue'),
      },
      {
        path: '/delivery/inorder',
        name: '配送分析',
        component: () => import('../views/delivery/inorder/index.vue'),
      },
      {
        path: '/expand/map',
        name: '门店地图',
        component: () => import('../views/expand/map/index.vue'),
      },
      {
        path: '/expand/contend',
        name: '竞对关系',
        component: () => import('../views/expand/contend/index.vue'),
      },
    ],
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/Login/index.vue'),
    meta: { title: '登录' }
  },
  {
    path: '/bind',
    name: 'Bind',
    component: () => import('@/views/Login/Bind.vue'),
    meta: { title: '绑定账号' }
  },
  {
    // 员工积分商城（与后台管理端隔离，企微一键登录）
    path: '/points',
    name: 'PointsEmployee',
    component: () => import('@/views/humanresources/pointdetail/employee/index.vue'),
    meta: { title: '积分商城', pointsEmployee: true }
  },
  financeRoutes,  // 添加财务路由模块
  humanResourcesRoutes,  // 确保这里正确导入了人力资源路由
  storeRoutes,  // 确保这个路由模块被包含
];

const router = createRouter({
  history: createWebHistory(),
  routes: routes,
});

export default router;